/**
 * Purity Fields quiz + bundle builder + chatbot
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* —— Quiz —— */
  function initQuiz(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var steps = qsa(root, '[data-quiz-step]');
    var result = qs(root, '[data-quiz-result]');
    var bar = qs(root, '[data-quiz-progress]');
    var answers = {};
    var index = 0;

    function show(i) {
      steps.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
      });
      if (result) result.hidden = true;
      if (bar) {
        bar.style.width = ((i + 1) / Math.max(steps.length, 1)) * 100 + '%';
      }
    }

    function scoreResult() {
      var scores = {};
      Object.keys(answers).forEach(function (k) {
        var tag = answers[k];
        if (!tag) return;
        scores[tag] = (scores[tag] || 0) + 1;
      });
      var best = null;
      var bestN = -1;
      Object.keys(scores).forEach(function (t) {
        if (scores[t] > bestN) {
          bestN = scores[t];
          best = t;
        }
      });
      return best || root.getAttribute('data-default-result') || 'creatine';
    }

    function finish() {
      var key = scoreResult();
      var card = qs(root, '[data-result-card="' + key + '"]') || qs(root, '[data-result-card]');
      steps.forEach(function (s) {
        s.classList.remove('is-active');
      });
      if (result) {
        result.hidden = false;
        qsa(result, '[data-result-card]').forEach(function (c) {
          c.hidden = c !== card;
        });
      }
      if (bar) bar.style.width = '100%';
    }

    qsa(root, '[data-quiz-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-quiz-step]');
        if (!step) return;
        qsa(step, '[data-quiz-option]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        answers[step.getAttribute('data-step-id') || index] = btn.getAttribute('data-result-tag');
      });
    });

    var next = qs(root, '[data-quiz-next]');
    var prev = qs(root, '[data-quiz-prev]');
    if (next) {
      next.addEventListener('click', function () {
        var step = steps[index];
        if (step && !qs(step, '.is-selected')) {
          step.classList.add('pf-quiz__shake');
          setTimeout(function () {
            step.classList.remove('pf-quiz__shake');
          }, 400);
          return;
        }
        if (index >= steps.length - 1) {
          finish();
          return;
        }
        index += 1;
        show(index);
        if (prev) prev.disabled = index === 0;
        next.textContent = index === steps.length - 1 ? 'See my results' : 'Next';
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        if (index === 0) return;
        index -= 1;
        show(index);
        prev.disabled = index === 0;
        if (next) next.textContent = 'Next';
        if (result) result.hidden = true;
      });
    }
    show(0);
  }

  /* —— Bundle builder —— */
  function initBundle(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var selected = {};
    var countEl = qs(root, '[data-bundle-count]');
    var totalEl = qs(root, '[data-bundle-total]');
    var discountEl = qs(root, '[data-bundle-discount]');
    var tiers = qsa(root, '[data-bundle-tier]');
    var subToggle = qs(root, '[data-bundle-subscribe]');
    var addBtn = qs(root, '[data-bundle-add]');
    var discountCode = root.getAttribute('data-discount-code') || '';

    function tierDiscount(n, subscribed) {
      var base = 0;
      if (n >= 3) base = parseFloat(root.getAttribute('data-discount-3') || '15');
      else if (n >= 2) base = parseFloat(root.getAttribute('data-discount-2') || '10');
      if (subscribed) base += parseFloat(root.getAttribute('data-discount-sub') || '5');
      return base;
    }

    function selectedList() {
      return Object.keys(selected).filter(function (id) {
        return selected[id];
      });
    }

    function refresh() {
      var ids = selectedList();
      var n = ids.length;
      var sub = !!(subToggle && subToggle.checked);
      var pct = tierDiscount(n, sub);
      var cents = 0;
      ids.forEach(function (id) {
        var card = qs(root, '[data-bundle-product="' + id + '"]');
        if (card) cents += parseInt(card.getAttribute('data-price-cents') || '0', 10);
      });
      var discounted = Math.round(cents * (1 - pct / 100));
      if (countEl) countEl.textContent = String(n);
      if (discountEl) discountEl.textContent = pct ? pct + '% off' : 'Add 2+ for discounts';
      if (totalEl) {
        totalEl.textContent = (discounted / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: root.getAttribute('data-currency') || 'USD'
        });
      }
      tiers.forEach(function (t) {
        var need = parseInt(t.getAttribute('data-need') || '0', 10);
        t.classList.toggle('is-active', n >= need && need > 0);
      });
      if (addBtn) addBtn.disabled = n < 1;
    }

    qsa(root, '[data-bundle-product]').forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-bundle-product');
        selected[id] = !selected[id];
        card.classList.toggle('is-selected', !!selected[id]);
        refresh();
      });
    });

    if (subToggle) subToggle.addEventListener('change', refresh);

    if (addBtn) {
      addBtn.addEventListener('click', async function () {
        var ids = selectedList();
        if (!ids.length) return;
        var items = ids.map(function (id) {
          var card = qs(root, '[data-bundle-product="' + id + '"]');
          var item = {
            id: parseInt(id, 10),
            quantity: 1,
            properties: {
              _bundle_builder: 'true',
              _bundle_items: String(ids.length)
            }
          };
          if (subToggle && subToggle.checked) {
            var plan = card && card.getAttribute('data-selling-plan');
            if (plan) item.selling_plan = parseInt(plan, 10);
          }
          return item;
        });

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) throw new Error('cart add failed');
          var code = discountCode;
          var n = ids.length;
          var sub = !!(subToggle && subToggle.checked);
          if (n >= 3) code = root.getAttribute('data-code-3') || code;
          else if (n >= 2) code = root.getAttribute('data-code-2') || code;
          if (sub) code = root.getAttribute('data-code-sub') || code;
          window.location.href = code ? '/cart?discount=' + encodeURIComponent(code) : '/cart';
        } catch (e) {
          console.error(e);
          alert('Could not add bundle to cart. Please try again.');
        }
      });
    }

    refresh();
  }

  /* —— Chatbot —— */
  function initChat(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var panel = qs(root, '[data-chat-panel]');
    var toggle = qs(root, '[data-chat-toggle]');
    var close = qs(root, '[data-chat-close]');
    var form = qs(root, '[data-chat-form]');
    var input = qs(root, '[data-chat-input]');
    var messages = qs(root, '[data-chat-messages]');
    var knowledge = [];
    var kid = root.getAttribute('data-knowledge-id');
    var knowledgeEl = kid ? document.getElementById(kid) : null;
    try {
      if (knowledgeEl) knowledge = JSON.parse(knowledgeEl.textContent || '[]');
      else knowledge = JSON.parse(root.getAttribute('data-knowledge') || '[]');
    } catch (e) {
      knowledge = [];
    }

    function addBubble(text, who) {
      var div = document.createElement('div');
      div.className = 'pf-chat__bubble pf-chat__bubble--' + who;
      div.textContent = text;
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
    }

    function reply(text) {
      var lower = (text || '').toLowerCase();
      var match = knowledge.find(function (k) {
        return (k.keywords || []).some(function (kw) {
          return lower.indexOf(String(kw).trim().toLowerCase()) !== -1;
        });
      });
      var fallback =
        root.getAttribute('data-fallback') ||
        'I can help with dose, timing, safety, and which Purity Fields product fits you. Try asking about creatine, dose, or take the quiz.';
      addBubble(match ? match.answer : fallback, 'bot');
    }

    function open() {
      if (panel) panel.classList.add('is-open');
    }
    function shut() {
      if (panel) panel.classList.remove('is-open');
    }

    if (toggle) toggle.addEventListener('click', function () {
      if (panel && panel.classList.contains('is-open')) shut();
      else open();
    });
    if (close) close.addEventListener('click', shut);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = (input && input.value || '').trim();
        if (!val) return;
        addBubble(val, 'user');
        input.value = '';
        setTimeout(function () {
          reply(val);
        }, 350);
      });
    }

    qsa(root, '[data-chat-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.getAttribute('data-chat-chip');
        open();
        addBubble(val, 'user');
        setTimeout(function () {
          reply(val);
        }, 350);
      });
    });

    var welcome = root.getAttribute('data-welcome');
    if (welcome) addBubble(welcome, 'bot');
  }

  function boot() {
    qsa(document, '[data-pf-quiz]').forEach(initQuiz);
    qsa(document, '[data-pf-bundle]').forEach(initBundle);
    qsa(document, '[data-pf-chat]').forEach(initChat);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
